import { BaseService } from 'core/services';
import ProductTypeRouteService from './ProductTypeRouteService';

class ProductTypeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ProductTypeRouteService());
    }
}

export default ProductTypeService;
